import { defineComponent } from 'vue'
import './index.scss'
import {
  ClientOnly,
  GfrCarousel,
  GfrCarouselSlide,
  GfrContainer,
  GfrImage,
  ModuleBase,
  ModuleBaseHeader
} from '#components'
import { moduleBaseProps } from '@/components/module/base'

import { sortArrayByKey } from '~/utils'

interface ImageWall {
  name: string
  url: string
  weight: number
}
export default defineComponent({
  name: 'ModuleHomeScreen3',
  props: {
    ...moduleBaseProps,
    title: String,
    subtitle: String,
    images: {
      type: Array as () => ImageWall[],
      default: () => []
    }
  },
  setup(props, { slots }) {
    const carouselSpeedHover = ref(0.5)
    const carouselSpeedOne = ref(0.8)
    const carouselSpeedTwo = ref(-1)
    const newImages = computed(() => {
      return sortArrayByKey(props.images, 'weight', 'dec') // down
    })
    const carouselOneData = computed(() => {
      return newImages.value.slice(0, Math.ceil(props.images.length / 2))
    })
    const carouselTwoData = computed(() => {
      return newImages.value.slice(Math.ceil(props.images.length / 2))
    })
    return () => (
      <ModuleBase name={props.name} class={'module-home-dreams-base'}>
        <GfrContainer>
          <ModuleBaseHeader title={props.title} description={props.subtitle || ''} />
        </GfrContainer>
        <section class={'module-home-dream-carousels'}>
          <ClientOnly>
            <GfrCarousel
              loop={true}
              effect={'gallery'}
              gap={Device().isMobile ? `0.5rem` : `1.5rem`}
              gallery={carouselSpeedOne.value}
              onMouseover={() => {
                carouselSpeedOne.value = carouselSpeedHover.value
              }}
              onMouseout={() => {
                carouselSpeedOne.value = 0.8
              }}
            >
              {carouselOneData.value?.map((item: any) => (
                <GfrCarouselSlide class={'module-home-dream-slide'}>
                  <GfrImage
                    class={'module-home-dream-image'}
                    lazy
                    src={item.url}
                    fit="cover"
                    name={item.name}
                    nameShow="override"
                  ></GfrImage>
                </GfrCarouselSlide>
              ))}
            </GfrCarousel>
            {/* TODO 调整方向 */}
            <GfrCarousel
              loop={true}
              effect={'gallery'}
              gallery={carouselSpeedTwo.value}
              gap={Device().isMobile ? `0.5rem` : `1.5rem`}
              onMouseover={() => {
                carouselSpeedTwo.value = -carouselSpeedHover.value
              }}
              onMouseout={() => {
                carouselSpeedTwo.value = -1
              }}
            >
              {carouselTwoData.value?.map((item: any) => (
                <GfrCarouselSlide class={'module-home-dream-slide'}>
                  <GfrImage
                    class={'module-home-dream-image'}
                    lazy
                    src={item.url}
                    fit="cover"
                    name={item.name}
                    nameShow="override"
                  ></GfrImage>
                </GfrCarouselSlide>
              ))}
            </GfrCarousel>
          </ClientOnly>
        </section>
      </ModuleBase>
    )
  }
})
